module.exports = __webpack_public_path__ + "img/page-060.4bb358b8.jpg";